// ============================================================================
// src/shared/api/httpClient.js
// Cliente HTTP ÚNICO (axios) para toda la app v2. baseURL desde env.
// Regla de arquitectura: NO crear otro axios.create() en ningún módulo;
// todas las llamadas pasan por aquí.
//
// NOTA de contrato con ESTE backend: el token de sesión viaja en el CUERPO de
// la petición (dataPOST.token), NO en un header. Por eso NO se agrega un
// interceptor de token (a diferencia del patrón AutoHub principal, que usa el
// header custom `token`). Si el backend migra a header, agregar aquí el
// interceptor de request. Ver docs/PLAN-MIGRACION-V2-SEGURIDAD-FRONTEND-2026-07-13.md
// ============================================================================
import axios from "axios";
import { env } from "../config/env";

export const httpClient = axios.create({
  baseURL: env.apiBaseUrl,
  // Antes 50 s: una request colgada bloqueaba el spinner hasta 50 s antes de fallar.
  // 30 s falla más rápido ante caídas, con margen para redes/BD lentas (la BD dev es
  // remota y con picos). No afecta a las cargas exitosas; sólo acota el peor caso.
  timeout: 30000,
});

export default httpClient;
